import {SeparatorType} from "@components/CustomTypography/Separator/Separator"
import {Translate} from "@components/Theme/Translate/Translate"
import {translateWithRouter} from "@helpers/translate"
import React from "react"

import styles from "./Checkbox.module.scss"

type Props = {
	container?: SeparatorType
	label: string
	name: string
	checked: boolean // Updated to use boolean for checkbox
	placeholder?: string
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
	onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
}

const CheckboxInput: React.FC<Props> = ({
	label,
	name,
	checked, // Updated to use boolean for checkbox
	placeholder,
	onChange,
	onBlur,
	container,
}) => {
	const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
		if (onBlur) {
			onBlur(event)
		}
		// No need to validate for checkboxes on blur
	}

	return (
		<div
			className={`${styles.inputContainer} ${container?.className}`}
			id={name}
		>
			<input
				checked={checked} // Use checked prop for checkbox
				className={styles.input}
				id={name}
				name={name}
				placeholder={translateWithRouter(placeholder || "")}
				type={"checkbox"} // Set type to checkbox
				onBlur={handleBlur}
				onChange={onChange}
			/>
			<label className={styles.label} htmlFor={name}>
				<Translate capitalize>{label}</Translate>{" "}
			</label>
		</div>
	)
}

export default CheckboxInput
